export default "__VITE_ASSET__DDd2y8rZ__"